import React, { useEffect, useState } from "react";
import ModifiersList from "./components/ModifierList";
import { useTranslation } from "react-i18next";
import { UTILS } from "utils";
import { errorHandler } from "api/api/errorHandler";
import { useDeleteModifierMutation } from "redux/modifiers/service";
import { useGetModifierListMutation } from "redux/modifiers/service";
import DeleteComponent from "components/DeleteConfirm";
import AppContainer from "components/ui/AppContainer";
import AppModal from "components/ui/AppModal";

const Modifiers = () => {
  const { t } = useTranslation();
  const [getModifierList] = useGetModifierListMutation();
  const [deleteModifier] = useDeleteModifierMutation();
  const [modifiers, setmodifiers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    deleteItemIndex: null,
    item: null,
  });
  const getAllModifiers = async () => {
    setLoading(true);
    try {
      const userDetail = UTILS.getCurrentUser();
      const { data } = await getModifierList({
        brandId: userDetail.brandId,
      });
      if (data?.success === 1 && data?.data) {
        setmodifiers(data.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllModifiers();
  }, []);

  const deleteSingleModifier = async (rowData) => {
    try {
      const item = modifiers[deleteModal.deleteItemIndex];
      setLoading(true);
      const userDetail = UTILS.getCurrentUser();
      const data = await deleteModifier({
        brandId: userDetail.brandId,
        modifierId: item._id,
      });
      if (data?.data?.success === 1) {
        UTILS.successNotification(
          data?.data?.message ?? t("Modifier Deleted Successfully")
        );
        let arr = [...modifiers];
        arr.splice(deleteModal.deleteItemIndex, 1);
        setmodifiers(arr);
      } else {
        UTILS.errorNotification(errorHandler(data?.error?.data));
      }
    } catch (error) {
      UTILS.errorNotification(errorHandler(error?.message));
    } finally {
      handleCancel();
      setLoading(false);
    }
  };

  const onClickDeleteButton = (row) => {
    const index = modifiers?.findIndex((obj) => obj?._id === row?._id);
    if (index !== -1) {
      const item = modifiers[index];
      setDeleteModal({ isOpen: true, deleteItemIndex: index, item: item });
    }
  };

  const handleCancel = () => {
    setDeleteModal({ isOpen: false, deleteItemIndex: -1, item: null });
  };

  return (
    <>
      <AppContainer
        title={t("Modifiers")}
        loading={loading}
        containerProps={{ className: "overflow-y-hidden" }}
      >
        <ModifiersList
          modifiers={modifiers}
          deleteModifier={onClickDeleteButton}
        />
      </AppContainer>
      <AppModal
        open={deleteModal.isOpen}
        modalWidth="rounded-md border border-gray-300 top-0"
        onClose={handleCancel}
      >
        <DeleteComponent
          loading={loading}
          onCancel={handleCancel}
          onDelete={deleteSingleModifier}
          title={deleteModal.item?.baseLanguage?.name}
          Heading={t(
            "will be permanentely deleted and removed from existing menus"
          )}
        />
      </AppModal>
    </>
  );
};

export default Modifiers;
